import { BaseModel } from '/@/modules/core/app/models/abstracts/BaseModel';

export class BillingCheckout extends BaseModel {
  /**
   * @var {string}
   */
  id;

  /**
   * @var {string}
   */
  resourceVersion;

  /**
   * @var {string}
   */
  type;

  /**
   * @var {string}
   */
  url;

  /**
   * @var {string}
   */
  state;

  /**
   * @var {boolean}
   */
  embed;

  /**
   * @var {string}
   */
  passThruContent;

  /**
   * @var {string}
   */
  createdAt;

  /**
   * @var {string}
   */
  updatedAt;

  /**
   * @var {string}
   */
  expiresAt;

  constructor(model = {}) {
    super();

    this.id = model.id;
    this.resourceVersion = model.resourceVersion;
    this.type = model.type;
    this.url = model.url;
    this.state = model.state;
    this.embed = model.embed;
    this.passThruContent = model.passThruContent;
    this.createdAt = model.createdAt;
    this.updatedAt = model.updatedAt;
    this.expiresAt = model.expiresAt;
  }
}
